"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Close = _interopRequireDefault(require("@p24/icons/Close"));

function _default(palette) {
  return {
    display: 'block',
    padding: "".concat(palette.gutter, "px ").concat(palette.gutter * 5, "px ").concat(palette.gutter, "px ").concat(palette.gutter, "px"),
    background: palette.elPrimary,
    border: "1px solid ".concat(palette.elPrimary),
    boxShadow: "0 8px 12px 0 ".concat(palette.elShadow, ", 0 6px 12px 0 ").concat(palette.elShadow),
    zIndex: palette.zOverlay,
    color: palette.tError,
    closeIcon: _Close["default"],
    width: 'auto',
    minWidth: 'auto',
    maxWidth: 'auto',
    borderRadius: '2px',
    textAlign: 'left'
  };
}